module.exports = __webpack_public_path__ + "@/assets/img/map-trip.15ac3fd1.svg";